/**
 * Revision History
 * 01/19/2022   ptkim           Create
 * 03/11/2022   hykim           Modified
 */
 import {SearchModelBase} from './SearchModelBase';
 import * as XCol from '../../framework.core/XExportColumn';
 
 export class OeBookingListItem extends SearchModelBase {
     id: number = 0;
     hBookingNo: string = '';
     hblNo: string = '';
     custName: string = '';
     refNo: string = '';
     cBookingNo: string = '';
     agentName: string = '';
     commodity: string = '';
     vessel: string = '';
     voyage: string = '';
     etd: string | null = null;
     fromEtd: string | null = null;
     toEtd: string | null = null;
     plofRec: string = '';
     loadingPort: string = '';
     disCharge: string = '';
     finalDest: string = '';
     plofDel: string = '';
     truckingCompany: string = '';
     truckingCompanyName: string | null = null;
     puCargoLocation: string = '';
     puCargoLocationName: string | null = null;
     moveType: string = '';
     portCutOff: string | null = null;
     fromPortCutOff: string | null = null;
     toPortCutOff: string | null = null;
     railCutOff: string | null = null;
     fromRailCutOff: string | null = null;
     toRailCutOff: string | null = null;
     bookRemark: string = '';
     exPref: string = '';
     createDate: string | null = null;
     fromCreateDate: string | null = null;
     toCreateDate: string | null = null;
     usLCode: string = '';
     unLCode: string = '';
     usDCode: string = '';
     unDCode: string = '';
     bookEtd: string | null = null;
     bookEta: string | null = null;
     agent: number = 0;
     carrier: number = 0;
     carrName: string = '';
     vesselCarrier: number = 0;
     vCarrName: string = '';
     status: string = '';
     bookDate: string | null = null;
     fromBookDate: string | null = null;
     toBookDate: string | null = null;
     bookedBy: string = '';
     quoteNo: string = '';
     consignee: string = '';
     conTypeAndQty: string = '';
     conType: string = '';
     pkgs: number = 0;
     fromBookEtd: string | null = null;
     toBookEtd: string | null = null;
     fromBookEta: string | null = null;
     toBookEta: string | null = null;
     puEmptyLoc: string = '';
     u2Date: string | null = null;
     fromU2Date: string | null = null;
     toU2Date: string | null = null;
     u2ID: string = '';
     u1ID: string = '';

     // Cloud Only
     puEmptyLocId: number = 0;
     rcveWhseId: number = 0;
     rcveWhse: string = '';
     confirmed: boolean = false;
     custContact: string = '';
     xtnNo: string = ''; //hbl
     sbl: boolean = false;

     private static ExportCollection: XCol.XExportColumn[] = [
         XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', align: XCol.XAlignType.Center, hiddenInColumnSetup: true}),
         XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'bookDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
         XCol.Create({ col: 2, text: 'Booking #', width: 100, dataIndex: 'hBookingNo', defaultColumnFocus : true}),
         XCol.Create({ col: 3, text: 'Book by', width: 80, dataIndex: 'bookedBy'}),
         XCol.Create({ col: 4, text: 'Customer', width: 120, dataIndex: 'custName'}),
         //XCol.Create({ col: 5, text: 'Contact', width: 120, dataIndex: 'custContact'}),
         XCol.Create({ col: 5, text: 'Consignee', width: 120, dataIndex: 'consignee'}),
         XCol.Create({ col: 6, text: 'Agent', width: 120, dataIndex: 'agentName'}),
         XCol.Create({ col: 7, text: 'Quotation #', width: 100, dataIndex: 'quoteNo'}),
         XCol.Create({ col: 8, text: 'HBL #', width: 100, dataIndex: 'hblNo'}),
         XCol.Create({ col: 9, text: 'Ref. #', width: 100, dataIndex: 'refNo'}),
         XCol.Create({ col: 10, text: 'Book CFM', width:75, dataIndex: 'confirmed', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center}),
         XCol.Create({ col: 11, text: 'Carrier\'s Book #', width: 100, dataIndex: 'cBookingNo'}),
         XCol.Create({ col: 12, text: 'Cargo Cutoff', width: 75, dataIndex: 'portCutOff', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
         XCol.Create({ col: 13, text: 'AES Doc Cutoff', width: 85, dataIndex: 'railCutOff', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
         XCol.Create({ col: 14, text: 'ITN #', width: 100, dataIndex: 'xtnNo'}),
         XCol.Create({ col: 15, text: 'CNTR Type/Qty', width: 120, dataIndex: 'conTypeAndQty'}),
        //  XCol.Create({ col: 14, text: 'Qty', width: 80, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
         XCol.Create({ col: 16, text: 'Move Type', width: 80, dataIndex: 'moveType', noNullOrEmptySearch: true}),
         XCol.Create({ col: 17, text: 'Commodity', width: 120, dataIndex: 'commodity'}),
         XCol.Create({ col: 18, text: 'Vessel Name', width: 120, dataIndex: 'vessel'}),
         XCol.Create({ col: 19, text: 'Voyage #', width: 80, dataIndex: 'voyage'}),
         XCol.Create({ col: 20, text: 'Loading Port', width: 120, dataIndex: 'loadingPort'}),
         XCol.Create({ col: 21, text: 'ETD', width: 75, dataIndex: 'bookEtd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
         XCol.Create({ col: 22, text: 'Discharge Port', width: 120, dataIndex: 'disCharge'}),
         XCol.Create({ col: 23, text: 'ETA', width: 75, dataIndex: 'bookEta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
         XCol.Create({ col: 24, text: 'Place of Receipt', width: 120, dataIndex: 'plofRec', visible: false}),
         XCol.Create({ col: 25, text: 'Place of Delivery', width: 120, dataIndex: 'plofDel', visible: false}),
         XCol.Create({ col: 26, text: 'Final Destination', width: 120, dataIndex: 'finalDest', visible: false}),
         XCol.Create({ col: 27, text: 'Trucking Vendor', width: 120, dataIndex: 'truckingCompanyName', hasCustomTooltip:true}),
        //  XCol.Create({ col: 27, text: 'P\'up Empty Cont. Loc', width: 250, dataIndex: 'puEmptyLoc'}),
         XCol.Create({ col: 28, text: 'P/U Cargo Location', width: 120, dataIndex: 'puCargoLocationName', hasCustomTooltip:true}),
         XCol.Create({ col: 29, text: 'Export Ref. #', width: 100, dataIndex: 'exPref'}),
         XCol.Create({ col: 30, text: 'Remark', width: 150, dataIndex: 'bookRemark', visible: false}),
         XCol.Create({ col: 31, text: 'Create Date', width: 100, dataIndex: 'createDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
         XCol.Create({ col: 32, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
         XCol.Create({ col: 33, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
         XCol.Create({ col: 34, text: 'Update by', width: 80, dataIndex: 'u2ID'}),

                 //for use tooltip
        XCol.Create({ col: 35, text: '', width: 0, dataIndex: 'truckingCompany', hiddenInColumnSetup: true, visible: false}), 
        XCol.Create({ col: 36, text: '', width: 0, dataIndex: 'puCargoLocation', hiddenInColumnSetup: true, visible: false}),
         ];
 
 
     public static getExportCollection(): XCol.XExportColumn[] {
         return this.ExportCollection;
     };
 
     public static MapOeSearchFields: {[key: string]: {[key: string]: string}} = {
         bookDate: {from: 'fromBookDate', to: 'toBookDate'},
         bookEta: {from: 'fromBookEta', to: 'toBookEta'},
         bookEtd: {from: 'fromBookEtd', to: 'toBookEtd'},
         portCutOff: {from: 'fromPortCutOff', to: 'toPortCutOff'},
         railCutOff: {from: 'fromRailCutOff', to: 'toRailCutOff'},
         dlvrToCarr: {from: 'fromDlvrToCarr', to: 'toDlvrToCarr'},
         createDate: {from: 'fromCreateDate', to: 'toCreateDate'},
         u2Date: {from: 'fromU2Date', to: 'toU2Date'},
     }
     
     public static OrderBy = { orderBy: OeBookingListItem.prototype.createDate, orderByAscending: false };
 
     public static formatData(data: OeBookingListItem[]) {
         return data.map((d: OeBookingListItem) => ({
           ...d,
         }));
     }
 
 }
 